"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _qs = _interopRequireDefault(require("qs"));
var _base = _interopRequireDefault(require("./base"));
var _models = require("../models");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * `Service` The Reviews service, is target to fetch reviews data.
 */
var Reviews = /*#__PURE__*/function (_Base) {
  /**
   * Create the reviews service instance.
   *
   * @param sdk - the SDK instance
   */
  function Reviews(sdk) {
    (0, _classCallCheck2["default"])(this, Reviews);
    return _callSuper(this, Reviews, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  (0, _inherits2["default"])(Reviews, _Base);
  return (0, _createClass2["default"])(Reviews, [{
    key: "createReview",
    value: (
    /**
     * Create review.
     *
     * @param projectId - is the project id
     * @param params - the query parameters. With the configurable option \{ force_create: true \}
     * @param payload -, review body.
     *     workflowId
     *     name,
     *     documents,
     *     rules,
     *     notes
     * @param config -  Configurable object for overwrite request parameters.. With the shape of
     * @returns a created review.
     */
    function () {
      var _createReview = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(projectId) {
        var params,
          payload,
          config,
          query,
          url,
          res,
          _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              payload = _args.length > 2 ? _args[2] : undefined;
              config = _args.length > 3 ? _args[3] : undefined;
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true,
                encode: false
              });
              url = "/projects/".concat(projectId, "/reviews").concat(query);
              _context.next = 7;
              return this.HttpService.dmV2.post(url, payload, config);
            case 7:
              res = _context.sent;
              return _context.abrupt("return", res.data || {});
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createReview(_x) {
        return _createReview.apply(this, arguments);
      }
      return createReview;
    }()
    /**
     * Send email to target users.
     *
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param payload - notification body
     *     assignees,
     *     notifiers,
     *     notes,
     *     taskId
     * @param config -  Configurable object for overwrite request parameters.. With the shape of
     * @returns empty data with status 201.
     */
    )
  }, {
    key: "sendEmailNotification",
    value: (function () {
      var _sendEmailNotification = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(projectId, reviewId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, "/notifications");
              _context2.next = 3;
              return this.HttpService.dmV2.post(url, payload, config);
            case 3:
              res = _context2.sent;
              return _context2.abrupt("return", res.data || null);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function sendEmailNotification(_x2, _x3, _x4, _x5) {
        return _sendEmailNotification.apply(this, arguments);
      }
      return sendEmailNotification;
    }()
    /**
     * Get reviews.
     *
     * @param projectId - is the project id
     * @param params - is to support pagination parameters
     *                             limit: 20
     *                             offset: 0
     * @param config - Configurable object for overwrite request parameters.
     */
    )
  }, {
    key: "getReviews",
    value: (function () {
      var _getReviews = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(projectId, params, config) {
        var query, url, response;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true,
                encode: false
              });
              url = "/projects/".concat(projectId, "/reviews").concat(query);
              _context3.next = 4;
              return this.HttpService.dmV2.get(url, config);
            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", {
                pagination: response.data.pagination || {},
                reviews: (response.data.results || []).map(_models.ReviewItem.parseV2)
              });
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getReviews(_x6, _x7, _x8) {
        return _getReviews.apply(this, arguments);
      }
      return getReviews;
    }()
    /**
     * Get a review.
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F2.0/BIM360-Docs.oas2.yml?view=%2Freviews%2Fgetreview
     *
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param params -, is to support pagination parameters
     *                           \{
     *                             folderDetails: boolean
     *                           \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns review.
     */
    )
  }, {
    key: "getReview",
    value: (function () {
      var _getReview = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(projectId, reviewId, params, config) {
        var query, url, res;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true,
                encode: false
              });
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId).concat(query);
              _context4.next = 4;
              return this.HttpService.dmV2.get(url, config);
            case 4:
              res = _context4.sent;
              return _context4.abrupt("return", res.data || {});
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getReview(_x9, _x10, _x11, _x12) {
        return _getReview.apply(this, arguments);
      }
      return getReview;
    }()
    /**
     * Terminate a review.
     * https://stoplight.autodesk.com/acs/bim360-docs/version%2F1.0/dm-v2.oas2.yml?view=/reviews/postprojectsprojectidreviewsreviewidterminate
     *
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param payload - with the shape of \{ notes \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns empty data with status 204.
     */
    )
  }, {
    key: "terminateReview",
    value: (function () {
      var _terminateReview = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(projectId, reviewId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, "/terminate");
              _context5.next = 3;
              return this.HttpService.dmV2.post(url, payload, config);
            case 3:
              res = _context5.sent;
              return _context5.abrupt("return", res.data || null);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function terminateReview(_x13, _x14, _x15, _x16) {
        return _terminateReview.apply(this, arguments);
      }
      return terminateReview;
    }()
    /**
     * Update review task.
     * https://stoplight.autodesk.com/acs/bim360-docs/version%2F1.0/dm-v2.oas2.yml?view=%2Ftasks%2Fpatchprojectsprojectidreviewsreviewidtaskstaskid
     *
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param taskId - is the task id
     * @param payload -, is the request body
     *     action,
     *     currentStep,
     *     notes
     * @param config - Configurable object for overwrite request parameters.
     * @returns updatedTask.
     */
    )
  }, {
    key: "updateTask",
    value: (function () {
      var _updateTask = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(projectId, reviewId, taskId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, "/tasks/").concat(taskId);
              _context6.next = 3;
              return this.HttpService.dmV2.patch(url, payload, config);
            case 3:
              res = _context6.sent;
              return _context6.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function updateTask(_x17, _x18, _x19, _x20, _x21) {
        return _updateTask.apply(this, arguments);
      }
      return updateTask;
    }()
    /**
     * Get review documents.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/branches/master/fc6e8e37f50f9-list-review-documents
     *
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param params - with the shape of \{ offset, limit \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns pagination and documents.
     */
    )
  }, {
    key: "getDocuments",
    value: (function () {
      var _getDocuments = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(projectId, reviewId, params, config) {
        var query, url, _yield$this$HttpServi, data;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true,
                encode: false,
                arrayFormat: 'repeat'
              });
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, "/versions").concat(query);
              _context7.next = 4;
              return this.HttpService.dmV2.get(url, config);
            case 4:
              _yield$this$HttpServi = _context7.sent;
              data = _yield$this$HttpServi.data;
              return _context7.abrupt("return", {
                pagination: data.pagination || {},
                documents: (data.results || []).map(_models.EntityItem.parseV2)
              });
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getDocuments(_x22, _x23, _x24, _x25) {
        return _getDocuments.apply(this, arguments);
      }
      return getDocuments;
    }()
    /**
     * Update review documents
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F3.0/Approval-Workflow.oas2.yml?view=%2Freviews%2Fupdatedocuments
     *
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param payload - with the shape of [\{ urn, name, attributtes, status \}]
     * @param config - Configurable object for overwrite request parameters.
     * @returns empty data with status 200.
     */
    )
  }, {
    key: "updateDocuments",
    value: (function () {
      var _updateDocuments = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(projectId, reviewId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, "/versions");
              _context8.next = 3;
              return this.HttpService.dmV3.patch(url, payload, config);
            case 3:
              res = _context8.sent;
              return _context8.abrupt("return", res.data);
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function updateDocuments(_x26, _x27, _x28, _x29) {
        return _updateDocuments.apply(this, arguments);
      }
      return updateDocuments;
    }()
    /**
     * Get review progress.
     * https://stoplight.autodesk.com/acs/bim360-docs/version%2F1.0/dm-v2.oas2.yml?view=/reviews/getprojectsprojectidreviewsreviewidprogress
     *
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param params - with the shape of \{ limit, offset \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns pagination and progressList
     */
    )
  }, {
    key: "getProgress",
    value: (function () {
      var _getProgress = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(projectId, reviewId, params, config) {
        var query, url, _yield$this$HttpServi2, data;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true,
                encode: false
              });
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, "/progress").concat(query);
              _context9.next = 4;
              return this.HttpService.dmV2.get(url, config);
            case 4:
              _yield$this$HttpServi2 = _context9.sent;
              data = _yield$this$HttpServi2.data;
              return _context9.abrupt("return", {
                pagination: data.pagination || {},
                progressList: data.results || []
              });
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getProgress(_x30, _x31, _x32, _x33) {
        return _getProgress.apply(this, arguments);
      }
      return getProgress;
    }()
    /**
     * Get execution process of a review
     * https://platform.stoplight.autodesk.com/docs/docs-cp/fce9369dfde97-get-review-executions
     *
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param params - with the shape of \{ filter[roundNum]: Integer \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns Return the executions by the round number.
     */
    )
  }, {
    key: "getExecutions",
    value: (function () {
      var _getExecutions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10(projectId, reviewId, params, config) {
        var query, url, _yield$this$HttpServi3, data;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, "/executions").concat(query);
              _context10.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              _yield$this$HttpServi3 = _context10.sent;
              data = _yield$this$HttpServi3.data;
              return _context10.abrupt("return", data);
            case 7:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getExecutions(_x34, _x35, _x36, _x37) {
        return _getExecutions.apply(this, arguments);
      }
      return getExecutions;
    }()
    /**
     * Get comments.
     * https://stoplight.autodesk.com/acs/bim360-docs/version%2F1.0/dm-v2.oas2.yml?view=%2Freviews%2Fgetprojectsprojectidreviewsreviewidcomments
     *
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param versionUrn - is the version urn
     * @param query - stringified options, is to support pagination parameters, limit=50&offset=0
     * @param config - Configurable object for overwrite request parameters.
     * @returns pagination and comment list.
     */
    )
  }, {
    key: "getComments",
    value: (function () {
      var _getComments = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee11(projectId, reviewId, versionUrn, query, config) {
        var url, _yield$this$HttpServi4, data;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, "/versions/").concat(encodeURIComponent(versionUrn), "/comments?").concat(query);
              _context11.next = 3;
              return this.HttpService.dmV2.get(url, config);
            case 3:
              _yield$this$HttpServi4 = _context11.sent;
              data = _yield$this$HttpServi4.data;
              return _context11.abrupt("return", {
                pagination: data.pagination || {},
                comments: data.results || []
              });
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function getComments(_x38, _x39, _x40, _x41, _x42) {
        return _getComments.apply(this, arguments);
      }
      return getComments;
    }()
    /**
     * Get review comments, this is for exporting excel.
     *
     * @param projectId - is the project id.
     * @param reviewId - is the review id.
     * @param params - with the shape of \{ limit, offset \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns pagination and comment list.
     */
    )
  }, {
    key: "getReviewComments",
    value: (function () {
      var _getReviewComments = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee12(projectId, reviewId, params, config) {
        var query, url, _yield$this$HttpServi5, data;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true,
                encode: false
              });
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, "/comments").concat(query);
              _context12.next = 4;
              return this.HttpService.dmV2.get(url, config);
            case 4:
              _yield$this$HttpServi5 = _context12.sent;
              data = _yield$this$HttpServi5.data;
              return _context12.abrupt("return", {
                pagination: data.pagination || {},
                comments: data.results || []
              });
            case 7:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getReviewComments(_x43, _x44, _x45, _x46) {
        return _getReviewComments.apply(this, arguments);
      }
      return getReviewComments;
    }()
    /**
     * Create a comment.
     * https://stoplight.autodesk.com/acs/bim360-docs/version%2F1.0/dm-v2.oas2.yml?view=%2Freviews%2Fpostprojectsprojectidreviewsreviewidversionsversionurncomments
     *
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param versionUrn - is the version urn
     * @param taskId - is the task id
     * @param message - is the comment message
     * @param config - Configurable object for overwrite request parameters.
     * @returns a created comment.
     */
    )
  }, {
    key: "createComment",
    value: (function () {
      var _createComment = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee13(projectId, reviewId, versionUrn, taskId, message, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, "/versions/").concat(encodeURIComponent(versionUrn), "/comments");
              _context13.next = 3;
              return this.HttpService.dmV2.post(url, {
                taskId: taskId,
                message: message
              }, config);
            case 3:
              res = _context13.sent;
              return _context13.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function createComment(_x47, _x48, _x49, _x50, _x51, _x52) {
        return _createComment.apply(this, arguments);
      }
      return createComment;
    }()
    /**
     * Batch create comments.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/acb1b1b2af020-comments-batch-create
     *
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param payload - with the shape of
     *                \{
     *                    comments, are the created comments, with the shape of \{ message, versionedUrn \}
     *                    stepId, is the corresponding step Id of the review
     *                    roundNum, is the corresponding round number of the review
     *                \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns with the shape of
     *                \{
     *                    results, are the created comments
     *                    errors, failed created version urn and failure reason
     *                \}
     */
    )
  }, {
    key: "batchCreateComments",
    value: (function () {
      var _batchCreateComments = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee14(projectId, reviewId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, "/comments:batch-create");
              _context14.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              res = _context14.sent;
              return _context14.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function batchCreateComments(_x53, _x54, _x55, _x56) {
        return _batchCreateComments.apply(this, arguments);
      }
      return batchCreateComments;
    }()
    /**
     * Update a comment.
     * https://stoplight.autodesk.com/acs/bim360-docs/version%2F1.0/dm-v2.oas2.yml?view=%2Freviews%2Fpatchprojectsprojectidreviewsreviewidversionsversionurncommentscommentid
     *
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param versionUrn - is the version urn
     * @param commentId -, is the comment id
     * @param message - is the updated message
     * @param config - Configurable object for overwrite request parameters.
     * @returns comment.
     */
    )
  }, {
    key: "updateComment",
    value: (function () {
      var _updateComment = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee15(projectId, reviewId, versionUrn, commentId, message, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, "/versions/").concat(encodeURIComponent(versionUrn), "/comments/").concat(commentId);
              _context15.next = 3;
              return this.HttpService.dmV2.patch(url, {
                message: message
              }, config);
            case 3:
              res = _context15.sent;
              return _context15.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function updateComment(_x57, _x58, _x59, _x60, _x61, _x62) {
        return _updateComment.apply(this, arguments);
      }
      return updateComment;
    }()
    /**
     * Delete a comment
     * https://stoplight.autodesk.com/acs/bim360-docs/version%2F1.0/dm-v2.oas2.yml?view=%2Freviews%2Fdeleteprojectsprojectidreviewsreviewidversionsversionurncommentscommentid
     *
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param versionUrn - is the version urn
     * @param commentId -, is the comment id
     * @param config - Configurable object for overwrite request parameters.
     * @returns deleted comment info with the shape of
     *                \{
     *                  createdAt, is the comment created time, such as "2020-08-25T03:45:12.854Z",
     *                  deletedAt, is the comment deleted time, such as "2020-08-25T03:45:12.854Z"
     *                  id, is the comment id, such as "23773"
     *                  updatedAt, is the comment updated time, such as "2020-08-17T09:17:38.097Z"
     *                \}
     */
    )
  }, {
    key: "deleteComment",
    value: (function () {
      var _deleteComment = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee16(projectId, reviewId, versionUrn, commentId, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, "/versions/").concat(encodeURIComponent(versionUrn), "/comments/").concat(commentId);
              _context16.next = 3;
              return this.HttpService.dmV2["delete"](url, config);
            case 3:
              res = _context16.sent;
              return _context16.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function deleteComment(_x63, _x64, _x65, _x66, _x67) {
        return _deleteComment.apply(this, arguments);
      }
      return deleteComment;
    }()
    /**
     * Update in progress review.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Workflows-V3.yaml/paths/~1projects~1%7Bproject_id%7D~1reviews~1%7Breview_id%7D/patch
     *
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param payload - with the shape of \{ workflow \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns review.
     */
    )
  }, {
    key: "updateReview",
    value: (function () {
      var _updateReview = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee17(projectId, reviewId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId);
              _context17.next = 3;
              return this.HttpService.dmV3.patch(url, payload, config);
            case 3:
              res = _context17.sent;
              return _context17.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function updateReview(_x68, _x69, _x70, _x71) {
        return _updateReview.apply(this, arguments);
      }
      return updateReview;
    }()
    /**
     * Get review activities.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Workflows-V3.yaml/paths/~1projects~1%7Bproject_id%7D~1reviews~1%7Breview_id%7D~1activities/get
     *
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param params - with the shape of \{ limit, nextAnchor \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns review.
     */
    )
  }, {
    key: "getReviewActivities",
    value: (function () {
      var _getReviewActivities = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee18(projectId, reviewId, params, config) {
        var query, url, res;
        return _regenerator["default"].wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true,
                encode: false
              });
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, "/activities").concat(query);
              _context18.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              res = _context18.sent;
              return _context18.abrupt("return", res.data || {});
            case 6:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function getReviewActivities(_x72, _x73, _x74, _x75) {
        return _getReviewActivities.apply(this, arguments);
      }
      return getReviewActivities;
    }()
    /**
     * Archive reviews.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/branches/josh%2FACSD-19736/reference/ACC-Workflows-V3.yaml/paths/~1projects~1%7Bproject_id%7D~1reviews:batch-archive/post
     *
     * @param projectId - is the project id
     * @param ids - , the array of review id
     * @param config - Configurable object for overwrite request parameters.
     * @returns review.
     */
    )
  }, {
    key: "archiveReviews",
    value: (function () {
      var _archiveReviews = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee19(projectId, ids, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews:batch-archive");
              _context19.next = 3;
              return this.HttpService.dmV3.post(url, ids, config);
            case 3:
              res = _context19.sent;
              return _context19.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function archiveReviews(_x76, _x77, _x78) {
        return _archiveReviews.apply(this, arguments);
      }
      return archiveReviews;
    }()
    /**
     * Batch copy versions.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/a4ebe6214be34-batch-copy-versions
     *
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param versionUrns - , the array of version urn
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise with object \{ commandId: Array[String] \}
     */
    )
  }, {
    key: "batchCopyVersions",
    value: (function () {
      var _batchCopyVersions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee20(projectId, reviewId, versionUrns, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, "/versions:batch-copy");
              _context20.next = 3;
              return this.HttpService.dmV3.post(url, versionUrns, config);
            case 3:
              res = _context20.sent;
              return _context20.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function batchCopyVersions(_x79, _x80, _x81, _x82) {
        return _batchCopyVersions.apply(this, arguments);
      }
      return batchCopyVersions;
    }()
    /**
     * Validate the copy versions errors
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Workflows-V3.yaml/paths/~1projects~1%7Bproject_id%7D~1reviews~1%7Breview_id%7D:validate-copy-versions/post
     *
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param payload -, request payload, empty by default
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise with object with shape:
     * \{
     *    errors:
     *    \{
     *     versions: \{ [urn]: \{ code: String \} \},
     *     review: [\{ code: String \}]
     *    \}
     * \}
     */
    )
  }, {
    key: "validateCopyVersions",
    value: (function () {
      var _validateCopyVersions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee21(projectId, reviewId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, ":validate-copy-versions");
              _context21.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              res = _context21.sent;
              return _context21.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function validateCopyVersions(_x83, _x84, _x85, _x86) {
        return _validateCopyVersions.apply(this, arguments);
      }
      return validateCopyVersions;
    }()
    /**
     * Create review from package.
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/reference/ACC-Packages-Management.yaml/paths/~1projects~1%7BprojectId%7D~1packages~1%7BpackageId%7D~1actions/post
     *
     * @param projectId -  the project uuid
     * @param packageId - , is the package id
     * @param data -, includes \{
     *     workflowId,
     *     name,
     *     documents,
     *     rules,
     *     notes
     * \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an object with the shape \{ actionResponse: object, status: string \}
     */
    )
  }, {
    key: "createReviewFromPackage",
    value: (function () {
      var _createReviewFromPackage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee22(projectId, packageId, data, config) {
        var url, payload, response;
        return _regenerator["default"].wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              url = "/projects/".concat(projectId, "/packages/").concat(packageId, "/actions");
              payload = {
                action: 'CREATE_REVIEW',
                data: data
              };
              _context22.next = 4;
              return this.HttpService.pkgV1.post(url, payload, config);
            case 4:
              response = _context22.sent;
              return _context22.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function createReviewFromPackage(_x87, _x88, _x89, _x90) {
        return _createReviewFromPackage.apply(this, arguments);
      }
      return createReviewFromPackage;
    }()
    /**
     * Move one step back during a review process.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/58682cd56b7bf-one-step-back
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param payload -, includes \{
     *    currentStepId,
     *    candidates,
     *    optionalCandidates,
     *    duration,
     *    notes
     * \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns review.
     */
    )
  }, {
    key: "oneStepBack",
    value: (function () {
      var _oneStepBack = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee23(projectId, reviewId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, ":step-back");
              _context23.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              res = _context23.sent;
              return _context23.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function oneStepBack(_x91, _x92, _x93, _x94) {
        return _oneStepBack.apply(this, arguments);
      }
      return oneStepBack;
    }()
    /**
     * Send a review to Initiator and set the review status as restarting
     * https://platform.stoplight.autodesk.com/docs/docs-cp/9fc9ada55a9b1-restart-review
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param payload -, includes \{
     *    stepId, indicates which step customers trigger the back to initiator process.
     *    notes
     * \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns roundNum.
     */
    )
  }, {
    key: "restartReview",
    value: (function () {
      var _restartReview = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee24(projectId, reviewId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, ":restart");
              _context24.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              res = _context24.sent;
              return _context24.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function restartReview(_x95, _x96, _x97, _x98) {
        return _restartReview.apply(this, arguments);
      }
      return restartReview;
    }()
    /**
     * Submit a new round of the opened review
     * https://platform.stoplight.autodesk.com/docs/docs-cp/d35fe223c64fd-submit-review-in-new-round
     * @param projectId - is the project id
     * @param reviewId - is the review id
     * @param payload -, includes \{
     *    documents, with the shape of \{ urn: string, name: string \}
     *    notes
     * \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns review.
     */
    )
  }, {
    key: "submitRestartingReview",
    value: (function () {
      var _submitRestartingReview = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee25(projectId, reviewId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, ":submit");
              _context25.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              res = _context25.sent;
              return _context25.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function submitRestartingReview(_x99, _x100, _x101, _x102) {
        return _submitRestartingReview.apply(this, arguments);
      }
      return submitRestartingReview;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Reviews';
    }
  }]);
}(_base["default"]);
var _default = exports["default"] = Reviews;